
import { BillingAddress } from "@/models/billing-address";
import Vue from "vue";
export default Vue.extend({
	props: {
		address: {
			type: Object as ()=>BillingAddress,
			required: true
		}
	},
	methods: {
		onEditClicked(){
			this.$emit("edit");
		}
	},
	i18nEx: {
		componentPrefix: "views.AccountActivate"
	},
});
